/* Crave Meal Prep — single-page order builder
 * Works with sections/crave-order-builder.liquid + snippets/crave-meal-card.liquid.
 * Uses only the standard Shopify Ajax Cart API (/cart/clear.js, /cart/add.js),
 * so it is independent of whichever subscription app runs the backend.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'crave-box-v1';

  function readStore() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }
  function writeStore(data) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      /* storage unavailable (private mode) — the box still works for this visit */
    }
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = format || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals':
          return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        case 'amount_with_comma_separator':
          return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator':
          return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        default:
          return withCommas + '.' + parts[1];
      }
    });
  }

  function Builder(root) {
    this.root = root;
    this.min = Number(root.getAttribute('data-min')) || 5;
    this.minSubtotal = Number(root.getAttribute('data-min-subtotal')) || 0; // cents; 0 = off
    this.minRule = root.getAttribute('data-min-rule') || 'meals'; // meals | either | both
    this.planName = (root.getAttribute('data-selling-plan-name') || '').toLowerCase();
    this.checkoutUrl = root.getAttribute('data-checkout-url') || '/checkout';
    this.moneyFormat = root.getAttribute('data-money-format');

    var dataEl = root.querySelector('[data-crave-products]');
    try {
      this.products = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('[Crave] Could not read product data', e);
      this.products = {};
    }

    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-crave-card]'));
    this.els = {
      count: root.querySelector('[data-count]'),
      hint: root.querySelector('[data-hint]'),
      fill: root.querySelector('[data-fill]'),
      track: root.querySelector('.crave-boxbar__track'),
      total: root.querySelector('[data-total]'),
      compare: root.querySelector('[data-compare]'),
      checkout: root.querySelector('[data-checkout]'),
      ctaLabel: root.querySelector('[data-cta-label]'),
      error: root.querySelector('[data-error]'),
      review: root.querySelector('[data-review]'),
      reviewBtn: root.querySelector('[data-open-review]'),
      reviewList: root.querySelector('[data-review-list]'),
      empty: root.querySelector('[data-empty]')
    };

    // items: { productId: { v: variantId, q: quantity } }
    this.items = {};
    // selected variant per product (even when quantity is 0)
    this.selected = {};

    var saved = readStore();
    var params = new URLSearchParams(window.location.search);
    this.mode = (saved && saved.mode) || root.getAttribute('data-mode-default') || 'subscribe';
    if (params.get('mode') === 'onetime' || params.get('mode') === 'subscribe') this.mode = params.get('mode');

    var self = this;
    Object.keys(this.products).forEach(function (pid) {
      var p = self.products[pid];
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      self.selected[pid] = first && first.id;
    });

    if (saved && saved.items) {
      Object.keys(saved.items).forEach(function (pid) {
        var entry = saved.items[pid];
        var variant = self.findVariant(pid, entry.v);
        if (variant && variant.available && entry.q > 0) {
          self.items[pid] = { v: variant.id, q: entry.q };
          self.selected[pid] = variant.id;
        }
      });
    }

    var protein = params.get('protein');
    if (protein === 'double') this.setAllProtein(1, true);
    if (protein === 'regular') this.setAllProtein(0, true);
    if (protein === 'double' || protein === 'regular') {
      root.querySelectorAll('[data-all-protein]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-all-protein') === (protein === 'double' ? '1' : '0')));
      });
    }

    this.bind();
    this.renderAll();
  }

  Builder.prototype.findVariant = function (pid, vid) {
    var p = this.products[pid];
    if (!p) return null;
    for (var i = 0; i < p.variants.length; i++) {
      if (String(p.variants[i].id) === String(vid)) return p.variants[i];
    }
    return null;
  };

  Builder.prototype.planFor = function (variant) {
    if (!variant || !variant.plans || !variant.plans.length) return null;
    var name = this.planName;
    if (name) {
      for (var i = 0; i < variant.plans.length; i++) {
        if (String(variant.plans[i].name).toLowerCase().indexOf(name) !== -1) return variant.plans[i];
      }
    }
    return variant.plans[0];
  };

  Builder.prototype.unitPrice = function (variant) {
    if (this.mode === 'subscribe') {
      var plan = this.planFor(variant);
      if (plan) return plan.price;
    }
    return variant.price;
  };

  Builder.prototype.bind = function () {
    var self = this;

    this.cards.forEach(function (card) {
      var pid = card.getAttribute('data-product-id');
      card.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn || !card.contains(btn)) return;

        if (btn.hasAttribute('data-variant-id')) {
          self.selectVariant(pid, btn.getAttribute('data-variant-id'));
        } else if (btn.hasAttribute('data-add') || btn.hasAttribute('data-inc')) {
          self.change(pid, 1);
        } else if (btn.hasAttribute('data-dec')) {
          self.change(pid, -1);
        }
      });
    });

    this.root.querySelectorAll('[data-mode]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.mode = btn.getAttribute('data-mode');
        self.save();
        self.renderAll();
      });
    });

    this.root.querySelectorAll('[data-all-protein]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.setAllProtein(Number(btn.getAttribute('data-all-protein')));
        self.root.querySelectorAll('[data-all-protein]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
      });
    });

    this.root.querySelectorAll('[data-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.filter(btn.getAttribute('data-filter'));
        self.root.querySelectorAll('[data-filter]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
      });
    });

    if (this.els.reviewBtn) {
      this.els.reviewBtn.addEventListener('click', function () {
        var open = self.els.review.hasAttribute('hidden');
        self.els.review.toggleAttribute('hidden', !open);
        self.els.reviewBtn.setAttribute('aria-expanded', String(open));
      });
    }

    if (this.els.reviewList) {
      this.els.reviewList.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-remove]');
        if (btn) self.change(btn.getAttribute('data-remove'), -1);
      });
    }

    var clear = this.root.querySelector('[data-clear]');
    if (clear) {
      clear.addEventListener('click', function () {
        self.items = {};
        self.save();
        self.renderAll();
      });
    }

    this.els.checkout.addEventListener('click', function () {
      self.checkout();
    });
  };

  Builder.prototype.selectVariant = function (pid, vid) {
    var variant = this.findVariant(pid, vid);
    if (!variant || !variant.available) return;
    this.selected[pid] = variant.id;
    if (this.items[pid]) this.items[pid].v = variant.id;
    this.save();
    this.renderCard(pid);
    this.renderBar();
  };

  Builder.prototype.setAllProtein = function (index, silent) {
    var self = this;
    Object.keys(this.products).forEach(function (pid) {
      var p = self.products[pid];
      if (p.addon || p.variants.length < 2) return;
      var v = p.variants[Math.min(index, p.variants.length - 1)];
      if (v && v.available) {
        self.selected[pid] = v.id;
        if (self.items[pid]) self.items[pid].v = v.id;
      }
    });
    if (!silent) {
      this.save();
      this.renderAll();
    }
  };

  Builder.prototype.change = function (pid, delta) {
    var current = this.items[pid];
    var q = (current ? current.q : 0) + delta;
    if (q <= 0) {
      delete this.items[pid];
    } else {
      this.items[pid] = { v: current ? current.v : this.selected[pid], q: Math.min(q, 99) };
    }
    this.hideError();
    this.save();
    this.renderCard(pid);
    this.renderBar();
  };

  Builder.prototype.filter = function (handle) {
    var shown = 0;
    this.root.querySelectorAll('[data-group="meals"] [data-crave-card]').forEach(function (card) {
      var tags = ' ' + (card.getAttribute('data-tags') || '') + ' ';
      var match = handle === 'all' || tags.indexOf(' ' + handle + ' ') !== -1;
      card.hidden = !match;
      if (match) shown++;
    });
    if (this.els.empty) this.els.empty.hidden = shown > 0;
  };

  Builder.prototype.save = function () {
    writeStore({ mode: this.mode, items: this.items });
  };

  Builder.prototype.counts = function () {
    var self = this;
    var meals = 0;
    var total = 0;
    var compare = 0;
    Object.keys(this.items).forEach(function (pid) {
      var item = self.items[pid];
      var p = self.products[pid];
      var v = self.findVariant(pid, item.v);
      if (!p || !v) return;
      if (!p.addon) meals += item.q;
      total += self.unitPrice(v) * item.q;
      compare += Math.max(v.price, v.compare || 0) * item.q;
    });
    return { meals: meals, total: total, compare: compare };
  };

  Builder.prototype.renderAll = function () {
    var self = this;
    this.root.querySelectorAll('[data-mode]').forEach(function (btn) {
      btn.setAttribute('aria-checked', String(btn.getAttribute('data-mode') === self.mode));
    });
    Object.keys(this.products).forEach(function (pid) {
      self.renderCard(pid);
    });
    this.renderBar();
  };

  Builder.prototype.renderCard = function (pid) {
    var self = this;
    var p = this.products[pid];
    if (!p) return;
    var vid = this.selected[pid];
    var variant = this.findVariant(pid, vid);
    var qty = this.items[pid] ? this.items[pid].q : 0;

    this.root.querySelectorAll('[data-crave-card][data-product-id="' + pid + '"]').forEach(function (card) {
      card.classList.toggle('is-in-box', qty > 0);

      card.querySelectorAll('[data-variant-id]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(String(b.getAttribute('data-variant-id')) === String(vid)));
      });

      var add = card.querySelector('[data-add]');
      var stepper = card.querySelector('[data-stepper]');
      if (add && stepper) {
        add.hidden = qty > 0;
        stepper.hidden = qty === 0;
        stepper.querySelector('[data-qty]').textContent = qty;
      }

      if (!variant) return;

      var price = card.querySelector('[data-price]');
      if (price) {
        price.innerHTML =
          (variant.compare > variant.price ? '<s>' + formatMoney(variant.compare, self.moneyFormat) + '</s>' : '') +
          formatMoney(variant.price, self.moneyFormat);
      }

      var plan = self.planFor(variant);
      var subsave = card.querySelector('[data-subsave]');
      if (subsave) {
        var showPlan = !!(plan && plan.price < variant.price);
        subsave.hidden = !showPlan;
        if (showPlan) subsave.querySelector('[data-sub-price]').textContent = formatMoney(plan.price, self.moneyFormat);
      }

      ['protein', 'carbs', 'fat', 'calories'].forEach(function (key) {
        var el = card.querySelector('[data-macro="' + key + '"]');
        var val = variant.macros && variant.macros[key];
        if (el && val !== '' && val != null) el.textContent = val + (key === 'calories' ? '' : 'g');
      });
    });
  };

  Builder.prototype.meetsMinimum = function (c) {
    var mealsOk = c.meals >= this.min;
    var moneyOk = this.minSubtotal > 0 && c.total >= this.minSubtotal;
    if (this.minRule === 'either' && this.minSubtotal > 0) return mealsOk || moneyOk;
    if (this.minRule === 'both' && this.minSubtotal > 0) return mealsOk && moneyOk;
    return mealsOk;
  };

  Builder.prototype.minimumHint = function (c) {
    var left = Math.max(this.min - c.meals, 0);
    var mealsText = 'Add ' + left + ' more meal' + (left === 1 ? '' : 's') + ' (' + this.min + ' minimum)';
    if (this.minSubtotal > 0 && this.minRule !== 'meals') {
      var moneyLeft = Math.max(this.minSubtotal - c.total, 0);
      var moneyText = 'spend ' + formatMoney(moneyLeft, this.moneyFormat) + ' more (' + formatMoney(this.minSubtotal, this.moneyFormat) + ' minimum)';
      if (this.minRule === 'either') return mealsText + ' or ' + moneyText;
      if (left > 0 && moneyLeft > 0) return mealsText + ' and ' + moneyText;
      if (moneyLeft > 0) return 'Almost there — ' + moneyText;
    }
    return mealsText;
  };

  Builder.prototype.renderBar = function () {
    var c = this.counts();
    var ok = this.meetsMinimum(c);
    var left = Math.max(this.min - c.meals, 0);

    this.els.count.textContent = c.meals;
    this.els.hint.textContent = ok
      ? 'Minimum reached — add more or check out'
      : this.minimumHint(c);
    this.els.hint.classList.toggle('is-ok', ok);
    this.els.fill.style.width = Math.min((c.meals / this.min) * 100, 100) + '%';
    this.els.fill.classList.toggle('is-ok', ok);
    if (this.els.track) this.els.track.setAttribute('aria-valuenow', String(Math.min(c.meals, this.min)));

    this.els.total.textContent = formatMoney(c.total, this.moneyFormat);
    if (this.els.compare) {
      var showCompare = c.compare > c.total;
      this.els.compare.hidden = !showCompare;
      this.els.compare.textContent = showCompare ? formatMoney(c.compare, this.moneyFormat) : '';
    }

    this.els.checkout.setAttribute('aria-disabled', String(!ok));
    this.els.ctaLabel.textContent = ok ? 'Checkout' : (left > 0 ? left + ' more to go' : 'Minimum not met');

    this.renderReview();
  };

  Builder.prototype.renderReview = function () {
    var self = this;
    if (!this.els.reviewList) return;
    var html = '';
    Object.keys(this.items).forEach(function (pid) {
      var item = self.items[pid];
      var p = self.products[pid];
      var v = self.findVariant(pid, item.v);
      if (!p || !v) return;
      var sub = v.title && v.title !== 'Default Title' ? v.title + ' • ' : '';
      html +=
        '<li>' +
        (p.image ? '<img src="' + p.image + '" alt="" loading="lazy" width="48" height="48">' : '<span></span>') +
        '<span><strong>' + item.q + ' × ' + escapeHtml(p.title) + '</strong><small>' + escapeHtml(sub) +
        formatMoney(self.unitPrice(v), self.moneyFormat) + ' each</small></span>' +
        '<button type="button" data-remove="' + pid + '" aria-label="Remove one ' + escapeHtml(p.title) + '">−</button>' +
        '</li>';
    });
    this.els.reviewList.innerHTML = html || '<li style="grid-template-columns:1fr">Your box is empty — add some meals.</li>';
  };

  Builder.prototype.showError = function (msg) {
    this.els.error.textContent = msg;
    this.els.error.hidden = false;
  };
  Builder.prototype.hideError = function () {
    this.els.error.hidden = true;
  };

  Builder.prototype.checkout = function () {
    var self = this;
    var c = this.counts();
    if (!this.meetsMinimum(c)) {
      this.showError(this.minSubtotal > 0 && this.minRule !== 'meals'
        ? 'Minimum not met yet: ' + this.minimumHint(c).charAt(0).toLowerCase() + this.minimumHint(c).slice(1) + '.'
        : 'Please choose at least ' + this.min + ' meals to check out.');
      return;
    }

    var lines = [];
    Object.keys(this.items).forEach(function (pid) {
      var item = self.items[pid];
      var v = self.findVariant(pid, item.v);
      if (!v) return;
      var line = { id: v.id, quantity: item.q };
      if (self.mode === 'subscribe') {
        var plan = self.planFor(v);
        if (plan) line.selling_plan = plan.id;
      }
      lines.push(line);
    });

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var btn = this.els.checkout;
    btn.setAttribute('aria-disabled', 'true');
    this.els.ctaLabel.textContent = 'Adding…';

    fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } })
      .then(function () {
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: lines })
        });
      })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add your meals.');
          return data;
        });
      })
      .then(function () {
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Box meals': String(c.meals), 'Purchase type': self.mode } })
        });
      })
      .then(function () {
        writeStore({ mode: self.mode, items: {} });
        window.location.href = self.checkoutUrl;
      })
      .catch(function (err) {
        self.showError(err.message);
        self.renderBar();
      });
  };

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-crave-builder]').forEach(function (el) {
      if (el.__craveBuilder) return;
      el.__craveBuilder = new Builder(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  // Re-init when the section is edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
